import React, {useEffect} from "react";
import {useNavigate} from "react-router";
import {useLocation, useMatch, useSearchParams} from "react-router-dom";
import {useApi} from "../hooks/api-hook";
import {API_SPEC} from "../spec/apiSpec";
import {saveLabels} from "../reducers/labelReducer";
import {useDispatch, useSelector} from "react-redux";
import {sets} from "../data/sets";
import {useKeycloak} from "@react-keycloak/web";
import {saveUser} from "../reducers/userReducer";
import {enqueueSnackbar} from "notistack";
import {saveSearchPrompt} from "../reducers/controlsReducer";

export default function MtgInitData() {

    const {keycloak, initialized: kInitialized} = useKeycloak();
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const location = useLocation();
    const {api, initialized} = useApi();
    const [searchParams, setSearchParams] = useSearchParams();
    const l = searchParams.get("l");

    let {id:sealedId} = {...useMatch("sealed/:id")?.params};
    let {firstSegment} = {...useMatch(":firstSegment")?.params};
    let {set: cardSet, no:cardNo, name: cardName} = {...useMatch(":set/:no/:name")?.params};
    let {set: cardSet1, no:cardNo1, name: cardName1, reverse: reverse} = {...useMatch(":set/:no/:name/:reverse")?.params};

    const {page: defaultPage, rowsPerPage: defaultRowsPerPage} = useSelector((state) => state.controlsReducer)


    useEffect(() => {
        if (location.pathname === "/") {
            navigate("/ltr");
            dispatch(saveSearchPrompt('set:ltr'));
        }
    }, []);

    React.useEffect(() => {
        console.debug(firstSegment)
        console.debug(sealedId)
        if (sealedId) {
            const q = sealedId.replaceAll("-", " ");
            sendCardById(sealedId);
            dispatch(saveLabels({searchResult: `Search results for: ${q}`}));
            dispatch(saveSearchPrompt(q));
            return;
        }

        if (restrictedFirstSegment.includes(firstSegment) || restrictedFirstSegment.includes(cardSet) || restrictedFirstSegment.includes(cardSet1)) {
            return;
        }

        if (firstSegment) {
            console.debug("loading set ...", firstSegment)
            sendCards(`set:${firstSegment}`);
            const setName = sets.find(s => s.code === firstSegment).name
            dispatch(saveLabels({searchResult: `Search results for: ${setName}`}));
            dispatch(saveSearchPrompt("set:" + firstSegment));
        } else if (cardSet && cardNo) {
            console.debug("loading card ...", cardSet, cardNo)
            sendCard(cardSet, cardNo, l);
            dispatch(saveSearchPrompt(cardName?.replaceAll("-", " ")));
        } else if (cardSet1 && cardNo1) {
            console.debug("loading card ...", cardSet1, cardNo1)
            sendCard(cardSet1, cardNo1, l);
            dispatch(saveSearchPrompt(cardName1?.replaceAll("-", " ") + " / " + reverse?.replaceAll("-", " ")));
        } else if (cardName) {
            console.debug("loading cards ...", cardName)
            sendCards(cardName);
            dispatch(saveSearchPrompt(cardName));
        }
    }, [sealedId, firstSegment, cardSet, cardSet1, initialized]);



    const sendCards = (value) => {
        const card_spec = API_SPEC.SEARCH_CARDS({q: value, page: defaultPage, size: defaultRowsPerPage})
        api(card_spec);
    }

    const sendCardById = (id) => {
        const card_spec = API_SPEC.SEARCH_CARD_BY_ID(id);
        api(card_spec);
    }

    const sendCard = (set, no) => {
        const card_spec = API_SPEC.SEARCH_CARD_BY_SET_AND_NO({set, no, lang: l, page: defaultPage, size: defaultRowsPerPage})
        api(card_spec);
    }


    useEffect(() => {
        if (!initialized) {
            console.debug('return')
            return;
        }

        const fetchUserInfo = async () => {
            try {
                const userProfile = await keycloak.loadUserInfo();
                console.log(userProfile)
                dispatch(saveUser({...userProfile, fullName: `${userProfile.given_name} ${userProfile.family_name}`}));
                enqueueSnackbar(`You are logged as ${userProfile.given_name} ${userProfile.family_name}`,  { autoHideDuration: 1000 })
            } catch (err) {
                enqueueSnackbar('fetch user data failed')
            }
        };

        if (keycloak.authenticated) {
            fetchUserInfo();
        }
    }, [kInitialized]);

}

export  const restrictedFirstSegment = ['search', 'sets', 'user', 'cart', 'sealed', 'shop', 'test', 'account', 'offers']
